import { wsService } from "./wsService";

const section = "dashboard";

function states_asn_count(param = {}) {
  return wsService.make_post_request(section + "/states-asn-count", param);
}

function states_shipment_count(param = {}) {
  return wsService.make_post_request(section + "/states-shipment-count", param);
}

function all_shipment_order(param = {}) {
  return wsService.make_post_request(section + "/all-shipment-order", param);
}

function all_asn(param = {}) {
  return wsService.make_post_request(section + "/all-asn", param);
}

function get_almacenamiento(param = {}) {
  return wsService.make_post_request(section + "/get-almacenamiento", param);
}

function active_operators(param = {}) {
  return wsService.make_post_request("employees/active-operators-with-tasks", param);
}

function lpn_pending_storage(param = {}) {
  return wsService.make_post_request(section + "/lpn-pending-storage", param);
}

export const dashboardService = {
  section,
  states_asn_count,
  states_shipment_count,
  all_shipment_order,
  all_asn,
  get_almacenamiento,
  active_operators,
  lpn_pending_storage,
};
